import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { AUTOMATED_ACTION_CRITERIA_ACTION_TYPE } from '../actions';

const initialState = {};

const automatedActionCriteriaReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case AUTOMATED_ACTION_CRITERIA_ACTION_TYPE.GET_AUTOMATED_ACTIONS:
        return payload || initialState;

      case AUTOMATED_ACTION_CRITERIA_ACTION_TYPE.CREATE_AUTOMATED_ACTION:
      case AUTOMATED_ACTION_CRITERIA_ACTION_TYPE.EDIT_AUTOMATED_ACTION:
        draft[payload.criteriaId] = payload;
        break;

      case AUTOMATED_ACTION_CRITERIA_ACTION_TYPE.CHANGE_ACTION_ORDER:
        payload.forEach(({ id, executionOrder }) => {
          draft[id].executionOptions.executionOrder = executionOrder;
        });
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default automatedActionCriteriaReducer;
